import { Box, Grid, Typography, useTheme } from '@mui/material';

import { capitalize } from 'lodash';

import { sxStyled } from '../styles';
import RenderBaggageIcons from '@shared/pages/Flights/components/RenderBaggageIcons';

const BaggageItem = ({ titleObj, flight, common_title }) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  return (
    <Grid item xs={common_title[1] ? 6 : 12} sx={sxStyle.centerBaggage}>
      <Box style={{ width: '90%' }}>
        <Typography sx={sxStyle.equipaje}>
          Equipaje {capitalize(titleObj?.title.toLowerCase())}
        </Typography>
        <Box sx={sxStyle.boxEquipaje}>
          <RenderBaggageIcons baggage={flight?.flight_baggage} />
        </Box>
      </Box>
    </Grid>
  );
};

export default BaggageItem;
